import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { EquipmentService } from '../../../services/equipment.service';
import { ReportTypeService } from '../../../services/reporttype.service';


@Component({
  selector: 'app-report-type-picker',
  templateUrl: './report-type-picker.component.html',
  styleUrls: ['./report-type-picker.component.scss']
})
export class ReportTypePickerComponent implements OnInit, OnChanges {
  @Input() id: number;
  @Input() _placeholder: string = 'Please Select';
  @Output() onIdSet = new EventEmitter<number>();
  @Output() onSet = new EventEmitter<any>();

  displayList = [];


  constructor(public reportTypeService: ReportTypeService) {
  }

  ngOnInit(): void {
    this.reportTypeService.getAll().then((list) => {
      this.displayList = list;
      //console.log("list");
      //console.log(list);
    });

  }

  ngOnChanges(changes: SimpleChanges): void {
    //console.log(changes);
    if (changes.id != null && changes.id.currentValue) {
      if (this.id != changes.id.currentValue)
        this.id = changes.id.currentValue;
    }
    //console.log(this.id);
  }

  onChanged() {
    this.onIdSet.emit(this.id);
    var item = this.displayList.find(a => a.id == this.id);
    this.onSet.emit(item);
  }

}
